import { Box } from '@mui/material';
import { useState } from 'react';
import { BaseAccordion } from '../../../../../Accordion/BaseAccordion';
import { ValidationBadge } from '../../ValidationBadge/ValidationBadge';
import { InstrumentIdentifiersProps } from './types';
// COMMENTED OUT: Holdings lookup functionality disabled
// import { HoldingsLookupPanel } from '../../HoldingsLookupPanel/HoldingsLookupPanel';
import { MappingAndRulesPanel } from './components/MappingAndRulesPanel/MappingAndRulesPanel';
import { useInstrumentIdentifiers } from './useInstrumentIdentifiers';
import './InstrumentIdentifiers.scss';

export const InstrumentIdentifiers = (props: InstrumentIdentifiersProps) => {
  const { validationResult } = useInstrumentIdentifiers(props);
  const [isMappingAndRulesPanelExpanded, setIsMappingAndRulesPanelExpanded] =
    useState(true);

  return (
    <BaseAccordion
      title="Instrument Identifiers"
      expanded={props.expanded}
      onChange={props.onChange}
      className="instrumentIdentifiers"
      badge={<ValidationBadge validationResult={validationResult} />}
    >
      <Box>
        {/* COMMENTED OUT: Holdings lookup functionality disabled */}
        {/* <HoldingsLookupPanel
          availableColumns={props.availableHeaders || []}
          config={holdingsLookup}
          onChange={setHoldingsLookup}
        /> */}

        {/* Mapping and Rules Panel - Contains ColumnMapping and RuleBuilder */}
        <MappingAndRulesPanel
          templateId={props.templateId}
          instrumentType={props.instrumentType}
          sectionId={props.sectionId}
          availableHeaders={props.availableHeaders || []}
          isExpanded={isMappingAndRulesPanelExpanded}
          onExpandedChange={setIsMappingAndRulesPanelExpanded}
        />
      </Box>
    </BaseAccordion>
  );
};
